/* eslint radix: ["error", "as-needed"] */
/* eslint-disable no-unexpected-multiline */
import React, { Component } from 'react';
import tinycolor from 'tinycolor2'
import generateId from './generateId'
// import prop from './functional'

const getRandomNumber = max =>  Math.floor(Math.random()*max)

export const direction = {
  left: {xv: -1, yv: 0},
  right: {xv: 1, yv: 0},
  up: {xv: 0,yv: -1},
  down: {xv: 0, yv: 1},
}


const newGameId = () => generateId(8)

export const initialState = {
  xv: 0, // snake x velocity
  yv: 0, // snake y velcocity
  px: 10, // player x
  py: 10, // player y
  ax: 15, // apple x
  ay: 15, // apple y
  tail: 5,
  defaultTail: 5,
  trail: [],
  boardSize: 400,
  gridSize: 20,
  tileCount: 20,
  baseSpeed: 1000/15,
  playerColor: 'lime',
  gameId: newGameId()
}


export const getGamePlayActions = (store) =>
({
  playerMotion: ({px,py, xv, yv}) => ({
    px: px + xv,
    py: py + yv
  }),
  wrapBoardBoundaries: ({px,py, tileCount}) => 
    px < 0 ? ({px: tileCount - 1}) :
    py < 0 ? ({py: tileCount - 1}) :
    px > tileCount - 1 ? ({px: 0}) :
    py > tileCount - 1 ? ({py: 0}) : 
    ({}),
  setTailAndGameIdOnFail: ({defaultTail, trail, px, py}) =>
   trail
     .map( i => i.x === px && i.y === py )
     .filter( i => i )
     .length > 0 ? ({tail: defaultTail, gameId: newGameId()}) : ({}),
  setTailOnWin: ({ax,ay,px,py, tileCount, tail}) => 
    ax === px && ay === py ? 
      ({
        tail: tail + 1,
        ax: getRandomNumber(tileCount),
        ay: getRandomNumber(tileCount),
      }) : ({}),
  manageTrail: ({ px, py, trail, tail}) => ({
    trail: [{x: px, y:py}].concat(trail).splice(0,tail) 
  })
})


const drawApple = ({ax,ay, gridSize}) => ctx => {
  ctx.fillStyle='white'
  ctx.fillRect(
    ax*gridSize,
    ay*gridSize,
    gridSize - 2, 
    gridSize - 2
  )
}

const drawPlayer = ({tail, trail, gridSize, playerColor}) => ctx => {
  
  trail.forEach( (i,index) =>  {
    ctx.fillStyle = tinycolor(playerColor).spin( (index - 1) * 15 );
    ctx.fillRect(
        i.x*gridSize,
        i.y*gridSize,
        gridSize -2, 
        gridSize -2
    )
  })
}

const drawBoard = ({boardSize}) => ctx => {
  ctx.fillStyle = 'black'
  ctx.fillRect(0,0, boardSize, boardSize);
}


class Snake extends Component {
  constructor(props){
    super(props)
    
    this.canvasContext = undefined
  }
  componentDidMount() {
    this.canvasContext = this.refs.canvas.getContext('2d');
    drawBoard(this.props)(this.canvasContext)
    
    
  }
  componentWillReceiveProps(props) {
    // console.log('sdf')
  }
  frameAdvance() {
    this.props.playerMotion(this.props)
    this.props.wrapBoardBoundaries(this.props)
    this.props.setTailAndGameIdOnFail(this.props)
    this.props.setTailOnWin(this.props)
    this.props.manageTrail(this.props)
    // const {px,py,ax,ay} = this.props

    // console.log(trail)

    drawBoard
      (this.props)
      (this.canvasContext)
    drawApple
      (this.props)
      (this.canvasContext)
    drawPlayer
      (this.props)
      (this.canvasContext)


  }
  render() {  
    return (
      <canvas 
        ref="canvas" 
        width={this.props.boardSize} 
        height={this.props.boardSize} />
    )
  }
}


export default Snake



// WEBPACK FOOTER //
// ./src/Snake.js